import routes from './routes';
import api from './api';

const config = {
    routes,
};

export { api, routes };

export default config;
